import React from 'react';
import ViewsProvider from '../../../../../utils/components/ViewsProvider';
import views from './views';

const Dashboards = () => <ViewsProvider views={views} />;

export default Dashboards;
